// Utility functions extracted from taskpane.js for modularity

export function addHttpTrace(actionExecutionHttpTrace) {
    if (!actionExecutionHttpTrace) {
        return;
    }

    var block = document.getElementById('actionHistory');
    var historyContainer = block.querySelector('#historyContainer');
    var template = block.querySelector('#historyRecordTemplate');

    for (var i = 0; i < actionExecutionHttpTrace.length; i++) {
        var httpTrace = actionExecutionHttpTrace[i];
        if (!httpTrace) {
            continue;
        }

        var recordBlock = template.cloneNode(true);
        recordBlock.id = 'historyRecord' + i;

        recordBlock.querySelector('.performedAt').textContent = httpTrace.performedAt || '';
        recordBlock.querySelector('.errorMessage').textContent = httpTrace.errorMessage || '';
        recordBlock.querySelector('.requestMethod').textContent = httpTrace.requestMethod || '';
        recordBlock.querySelector('.requestUrl').textContent = httpTrace.requestUrl || '';
        recordBlock.querySelector('.requestBody').textContent = httpTrace.requestBody || '';

        if (httpTrace.responseStatus) {
            recordBlock.querySelector('.responseStatus').textContent = httpTrace.responseStatus;
        } else {
            var responseStatusBlock = recordBlock.querySelector('.responseStatusBlock');
            if (responseStatusBlock) {
                responseStatusBlock.style.display = 'none';
            }
        }

        recordBlock.querySelector('.responseHeaders').textContent = httpTrace.responseHeaders || '';
        recordBlock.querySelector('.responseBody').textContent = httpTrace.responseBody || '';

        recordBlock.style.display = 'block';
        historyContainer.appendChild(recordBlock);
    }

    block.style.display = 'block';

    // Remove any existing click listeners by replacing the element
    var actionCopy = block.querySelector('.actioncopy');
    var newActionCopy = actionCopy.cloneNode(true);
    actionCopy.parentNode.replaceChild(newActionCopy, actionCopy);

    newActionCopy.addEventListener('click', function (event) {
        event.stopPropagation();
        var str = historyContainer.textContent;
        // Trim heading blank spaces for each line
        str = str.replace(/^[\s]+/gm, '');
        copyToClipboard(str);
    });
}

export function copyToClipboard(str) {
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}